<template>
  <div class="card height-equal">
    <div class="card-header">
      <h5>Acente - Onay Bekleyenler</h5>
    </div>
    <div class="card-body">
      <div class="upcoming-event">
        <div class="upcoming-innner media" v-for="item in items" :key="item.Id">
          <div class="bg-primary left m-r-20">
            <feather type="share-2"></feather>
          </div>
          <div class="media-body">
            <p class="mb-0">
              {{ item.Adi }}
              <span class="pull-right">{{ formatDate(item.KayitTarihi) }}</span>
            </p>
            <h6 class="f-w-600">{{ item.YetkiliAdi }}</h6>
            <p class="mb-0">
              <strong>Şehir :</strong> {{ item.SehirAdi }}<br />
              <strong>Cep Telefonu : </strong> {{ item.GSM }}<br />
              <strong>Email : </strong> {{ item.Email }}
            </p>
            <b-btn-group>
              <router-link
                :to="`/acente/detay/${item.Id}`"
                class="btn btn-dark btn-xs"
                >Detay</router-link
              >
              <router-link
                :to="`/acente/kayit/${item.Id}`"
                class="btn btn-info btn-xs"
                >Düzelt</router-link
              >
              <b-button size="xs" @click="onayla(item)" variant="success"
                >Onayla</b-button
              >
              <b-button size="xs" @click="iptalEt(item)" variant="warning"
                >İptal Et</b-button
              >
            </b-btn-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.onList();
  },
  methods: {
    formatDate(date) {
      return this.$formatHelper.formatDate(date);
    },
    onList() {
      let vm = this;

      this.$connection.get("/acenteler/onayBekleyenler", function (response) {
        vm.items = response;
      });
    },
    onayla(item) {
      let vm = this;
      this.$alert.confirm(
        "Onayla",
        "Acenteyı onaylamak istediğinize emin misiniz?",
        "warning",
        function () {
          vm.$connection.get(
            "/acenteler/onayla/" + item.Id,
            function (response) {
              if (response.Success) {
                vm.$alert.messageWithFunction(
                  "Onaylandı",
                  "Acente onaylandı.",
                  "success",
                  function () {
                    vm.$listHelper.removeItem(vm.items, item);
                  }
                );
              }
            }
          );
        }
      );
    },
    iptalEt(item) {
      let vm = this;
      this.$alert.confirm(
        "İptal Et",
        "Acente aynı bilgilerle bir daha üye olamayacak. İptal etmek istedğinize emin misiniz?",
        "warning",
        function () {
          vm.$connection.get(
            "/acenteler/durumDegistir/" + item.Id + "/100",
            function (response) {
              if (response.Success) {
                vm.$alert.messageWithFunction(
                  "İptal Edildi",
                  "Acente iptal edildi.",
                  "success",
                  function () {
                    vm.$listHelper.removeItem(vm.items, item);
                  }
                );
              }
            }
          );
        }
      );
    },
  },
};
</script>
